import Cookies from 'js-cookie'

const TokenKey = 'pc_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

//-----------处理其他cookie信息-----------------
export const cookieKeys = {
  phone: 'phone', //手机号
}
export function getCookieItem(key) {
  return Cookies.get(key)
}

export function setCookieItem(key, value) {
  return Cookies.set(key, value)
}

export function removeCookieItem(key) {
  return Cookies.remove(key)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js